const CodyPreset = Object.freeze({
  ADD_A_SURPRISE: 'add_a_surprise',
  MAKE_MORE_RELAXED: 'make_more_relaxed',
  MAKE_MORE_ACTIVE: 'make_more_active',
} as const);

export type CodyPreset = (typeof CodyPreset)[keyof typeof CodyPreset];

export const allCodyPresets: [CodyPreset, ...CodyPreset[]] = Object.values(CodyPreset) as [
  CodyPreset,
  ...CodyPreset[],
];

export default CodyPreset;
